import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ThemeProvider } from "next-themes";
import { ContentProvider } from "@/contexts/ContentContext";

// PrimeReact CSS (non-theme files)
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 Unhandled Promise Rejection:', {
    reason: event.reason,
    promise: event.promise,
    stack: event.reason?.stack
  });
  
  // Prevent the default error display (red banner)
  event.preventDefault();
  
  // Show a user-friendly error toast instead
  // Note: This will work once the app is loaded and toast is available
  if (window.toast) {
    window.toast.error('An unexpected error occurred. Please try again.');
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <ContentProvider>
        <App />
      </ContentProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
